/* CILSON – Produktseite: In den Warenkorb ohne Weiterleitung, mit Bestätigung */
(() => {
  if (window.cilsonPdpAtc) return;
  window.cilsonPdpAtc = true;

  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const THR = 150;
  const eur = (cents) => (cents / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  const ICON_OK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
  const ICON_X = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';

  let pop, hideTimer, returnFocus;
  let labels = {};
  try { labels = JSON.parse(document.getElementById('cil-mobile-order-config').textContent).labels; } catch (_) {}
  const mobile = () => window.matchMedia('(max-width: 749px)').matches;
  const ensurePop = () => {
    if (pop) return pop;
    pop = document.createElement('div');
    pop.className = 'cil-atc-pop';
    pop.setAttribute('role', 'region');
    pop.setAttribute('aria-label', labels.confirmation || 'Warenkorb');
    pop.tabIndex = -1;
    pop.inert = true;
    document.body.appendChild(pop);
    pop.addEventListener('mouseenter', () => clearTimeout(hideTimer));
    pop.addEventListener('focusin', () => clearTimeout(hideTimer));
    pop.addEventListener('click', (e) => {
      if (e.target.closest('.cil-atc-x, .cil-atc-weiter')) hide();
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') hide(); });
    return pop;
  };
  const hide = () => {
    if (pop) { pop.classList.remove('an'); pop.inert = true; }
    document.body.classList.remove('cil-atc-open');
    clearTimeout(hideTimer);
    if (mobile() && returnFocus && returnFocus.isConnected) returnFocus.focus({ preventScroll: true });
  };
  const show = (html, ms) => {
    ensurePop().innerHTML = html;
    pop.inert = false;
    document.body.classList.add('cil-atc-open');
    requestAnimationFrame(() => pop.classList.add('an'));
    clearTimeout(hideTimer);
    if (!mobile()) hideTimer = setTimeout(hide, ms);
    if (mobile()) requestAnimationFrame(() => pop.focus({ preventScroll: true }));
  };

  const refreshBubble = async () => {
    const bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    try {
      const r = await fetch(ROOT + '?sections=cart-icon-bubble');
      const html = (await r.json())['cart-icon-bubble'];
      const s = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
      if (s) bubble.innerHTML = s.innerHTML;
    } catch (e) {}
  };

  const thumb = (url) => {
    if (!url) return '';
    try { const u = new URL(url, location.origin); u.searchParams.set('width', '160'); return u.toString(); } catch (e) { return url; }
  };

  const onSubmit = async (e) => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.closest('.product__info-container product-form')) return;
    e.preventDefault();
    e.stopPropagation();

    if (!form.reportValidity()) return;
    const btn = form.querySelector('.product-form__submit');
    returnFocus = document.activeElement;
    if (btn && btn.classList.contains('cil-busy')) return;
    const spinner = btn && btn.querySelector('.loading-overlay__spinner');
    if (btn) { btn.classList.add('cil-busy'); btn.setAttribute('aria-disabled', 'true'); }
    if (spinner) spinner.classList.remove('hidden');

    let addSucceeded = false;
    try {
      const fd = new FormData(form);
      const variantId = String(fd.get('id') || '');
      const r = await fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd });
      const added = await r.json();
      if (!r.ok) throw added;
      addSucceeded = true;

      const cartResponse = await fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } });
      if (!cartResponse.ok) throw new Error('Cart refresh failed');
      const cart = await cartResponse.json();
      const lines = (cart.items || []).filter((i) => String(i.variant_id) === variantId);
      const qty = lines.reduce((s, i) => s + i.quantity, 0);
      const finalTotal = lines.reduce((s, i) => s + i.final_line_price, 0);
      const origTotal = lines.reduce((s, i) => s + i.original_line_price, 0);
      const save = origTotal - finalTotal;
      const title = (added.product_title || added.title || '').split(' – ')[0];
      const total = cart.total_price;
      let market = {};
      try { market = JSON.parse(document.getElementById('cil-mobile-order-config').textContent); } catch (_) {}
      const showFreeShipping = !mobile() || (market.country === 'DE' && cart.currency === 'EUR');
      // 24.10.2026: Positionen mit eigenem 0-€-Versandprofil (Tag „versandkostenfrei“, window.cilFreeVids aus cilson-b2b-mode)
      // zählen nicht zur 150-€-Grenze; besteht der Warenkorb nur aus solchen Positionen, ist der Versand frei.
      const freeVids = (window.cilFreeVids || []).map(String);
      const freePart = (cart.items || []).filter((i) => freeVids.includes(String(i.variant_id))).reduce((s, i) => s + i.final_line_price, 0);
      const general = total - freePart;
      const left = general <= 0 ? 0 : THR * 100 - general;
      const pct = Math.max(4, Math.min(100, Math.round((general / (THR * 100)) * 100)));

      const qc = document.querySelector('.product__info-container .quantity-cart');
      if (qc) qc.textContent = '(' + qty + ' im Warenkorb)';

      show(
        '<div class="cil-atc-head">' + ICON_OK + '<span>In den Warenkorb gelegt</span>' +
          '<button type="button" class="cil-atc-x" aria-label="Schließen">' + ICON_X + '</button></div>' +
        '<div class="cil-atc-item">' + (added.image ? '<img src="' + thumb(added.image) + '" alt="">' : '') +
          '<div class="cil-atc-meta"><div class="cil-atc-t"></div>' +
          '<div class="cil-atc-q">Im Warenkorb: <b>' + qty + ' St.</b> · <b>' + eur(finalTotal) + '</b></div>' +
          (save > 0 ? '<span class="cil-atc-save">Staffelpreis-Ersparnis ' + eur(save) + '</span>' : '') +
        '</div></div>' +
        (showFreeShipping ? '<p class="cil-atc-free' + (left <= 0 ? ' ok' : '') + '">' +
          (left <= 0 ? 'Kostenloser Versand erreicht' : 'Noch ' + eur(left) + ' bis zum kostenlosen Versand') +
          (left > 0 ? '<span class="cil-atc-bar"><i style="width:' + pct + '%"></i></span>' : '') + '</p>' : '') +
        '<p class="cil-atc-cart-total"><span></span><b>' + eur(cart.total_price) + '</b></p>' +
        '<div class="cil-atc-btns"><button type="button" class="cil-atc-weiter">Weiter einkaufen</button>' +
          '<a class="cil-atc-cart" href="' + ROOT + 'cart">Zum Warenkorb (' + cart.item_count + ')</a>' +
          '<form class="cil-atc-checkout" action="' + ROOT + 'cart" method="post"><button type="submit" name="checkout"></button></form></div>',
        9000
      );
      pop.querySelector('.cil-atc-t').textContent = title;
      pop.querySelector('.cil-atc-checkout button').textContent = labels.checkout || 'Zur Kasse';
      pop.querySelector('.cil-atc-cart-total span').textContent = labels.subtotal || 'Warenwert';
      if (mobile()) {
        pop.querySelector('.cil-atc-cart').textContent = (labels.cart || 'Warenkorb prüfen') + ' (' + cart.item_count + ')';
        pop.querySelector('.cil-atc-weiter').textContent = labels.continue || 'Weiter auswählen';
      }

      refreshBubble();
      document.dispatchEvent(new CustomEvent('cilson:cart-updated', { detail: { variantId, cart } }));
      if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
        try { window.publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cilson-pdp', productVariantId: variantId, cartData: cart }); } catch (x) {}
      }
    } catch (err) {
      if (addSucceeded) {
        show('<div class="cil-atc-head"><span></span><button type="button" class="cil-atc-x" aria-label="Schließen">' + ICON_X + '</button></div><a class="cil-atc-cart" href="' + ROOT + 'cart"></a>', 9000);
        pop.querySelector('.cil-atc-head span').textContent = labels.addedFallback || 'Artikel hinzugefügt. Bitte prüfen Sie Ihren Warenkorb.';
        pop.querySelector('.cil-atc-cart').textContent = labels.cart || 'Warenkorb prüfen';
        refreshBubble();
        return;
      }
      const msg = (err && (err.description || err.message)) || 'Der Artikel konnte nicht hinzugefügt werden. Bitte erneut versuchen.';
      show('<div class="cil-atc-head"><span>Hinweis</span><button type="button" class="cil-atc-x" aria-label="Schließen">' + ICON_X + '</button></div>' +
        '<p class="cil-atc-err"></p>', 7000);
      pop.querySelector('.cil-atc-err').textContent = msg;
    } finally {
      if (btn) { btn.classList.remove('cil-busy'); btn.removeAttribute('aria-disabled'); }
      if (spinner) spinner.classList.add('hidden');
    }
  };

  document.addEventListener('submit', onSubmit, true);
})();
